export const getTypeFormResponse = async (responseId) => {
  const firstNameFieldRef = "66d7b5a0-38af-4b68-a60f-54763d493905";
  const lastNameFieldRef = "a7e9e99a-fcea-4a12-aa9c-049340f90ff1";

  const response = await fetch(
    `${process.env.REACT_APP_API_URL}/form-response/${responseId}`
  );

  const data = await response.json();
  const answers = data?.items?.[0]?.answers || [];

  const answersMap = answers.reduce((acc, answer) => {
    let key = answer.field.ref;

    if (answer.type === "email" || answer.type === "phone_number") {
      key = answer.type;
    }

    // handle multiple choice
    if (answer.type === "choices" && answer.choices) {
      const value = answer.choices.labels.join(", ");
      acc[key] = value;
      return acc;
    }

    // shape of answer when type is choice { choice: {} , type: 'choice' }
    let value = answer.choice?.label;

    // shape of answer is { email: 'test@test.com', type: 'email' }
    if (!value) {
      value = answer[answer.type];
    }

    if (key === firstNameFieldRef) {
      return {
        ...acc,
        first_name: value,
      };
    }

    if (key === lastNameFieldRef) {
      return {
        ...acc,
        last_name: value,
      };
    }

    acc[key] = value;
    return acc;
  }, {});

  return { answers, answersMap };
};
